import React from 'react';
import Error from '@pages/error';
import { appInsights } from '../../telemetry-service';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleRetry = this.handleRetry.bind(this);
  }

  handleRetry() {
    this.setState({ hasError: false });
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);

    try {
      sessionStorage.setItem(
        'lastError',
        JSON.stringify({
          message: error?.message,
          stack: error?.stack,
          componentStack: errorInfo?.componentStack,
          url: window.location.href,
          timestamp: Date.now()
        })
      );
    } catch (e) {
      console.warn('[ErrorBoundary] suppressed:', e);
    }

    try {
      appInsights.trackException({
        exception: error,
        properties: {
          componentStack: errorInfo?.componentStack,
          url: window.location.href
        }
      });
    } catch (e) {
      console.warn('[ErrorBoundary] suppressed:', e);
    }
  }

  render() {
    if (this.state.hasError) {
      return <Error onRetry={this.handleRetry} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
